package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Visibility
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.visibility
import com.varabyte.kobweb.silk.components.graphics.Image
import kotlinx.browser.document

@Composable
fun WebImage(
    src: String,
    contentDescription: String,
    modifier: Modifier = Modifier,
    lazyLoading: Boolean = true,
) {
    val imageId = "imageId${contentDescription}"

    Image(
        src = src,
        alt = contentDescription,

        modifier = modifier
            .id(imageId)
            .attrsModifier {
                if (lazyLoading) {
                    attr("loading", "lazy")
                    attr("alt", contentDescription)
                }
                /*style {
                    property("width", "100%")
                    property("height", if (height != null) "100%" else "auto")
                    property("display", "block")
                    if (height != null) property("object-fit", "cover")
                }
                addEventListener("load") { event ->
                    val img = event.target.asDynamic()
                    val nw = img.naturalWidth as? Int ?: 0
                    val nh = img.naturalHeight as? Int ?: 0
                    if (nw > 0 && nh > 0) {
                        val renderedH = (estimatedWidthPx * nh.toDouble() / nw.toDouble()).toInt()
                        imageDims = estimatedWidthPx to renderedH
                    }
                }*/
            }


    )
}
